export default "__VITE_ASSET__CoWM7aap__"